import { render, staticRenderFns } from "./OnsiteDisposalPlan.vue?vue&type=template&id=22dc99aa&scoped=true"
import script from "./OnsiteDisposalPlan.vue?vue&type=script&lang=js"
export * from "./OnsiteDisposalPlan.vue?vue&type=script&lang=js"
import style0 from "./OnsiteDisposalPlan.vue?vue&type=style&index=0&id=22dc99aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc99aa",
  null
  
)

export default component.exports